export const QUERY_KEYS = {
  chatId: "chaId",
  allChat: "allChat"
} as const;
